<!-- modal.component.html -->
<div class="fixed inset-0 z-40 flex items-center justify-center bg-black/15 backdrop-blur-sm" (click)="onClose()">
  <div class="bg-white rounded-lg shadow-xl p-6 w-full mx-4 max-w-[80%] max-h-4/5 overflow-y-auto" (click)="$event.stopPropagation()">

    <ng-content></ng-content>

  </div>
</div>